import React, { useContext } from 'react';
import { MuiAppContext, MuiPaginationServerSideProps } from '@lsoft/mui';
import _ from 'lodash';
import { ShopProductGroupGrid } from '../src/components/Product/ShopProductGroupGrid';
import { ShopPage } from '../src/app/ShopPage';
import PropTypes from 'prop-types';
import { getTranslation } from '@lsoft/translate';
import { shopServerSideProps } from '../src/tools/withShopPropsContext';
import { compose } from 'redux';
import { PageHeader } from '../src/components/PageHeader';
import { GTMProductList } from '../src/container/shop/GTMProductList';
import { apiGroupTagsRead } from '@lsoft/shared/api/group_tags';

const Group = ({ grouptags, paginationViewParams, ...pageProps }) => {
	const { scrollTop } = useContext(MuiAppContext);
	const title = _.get(pageProps, 'pageInfo.title', null);
	return (
		<ShopPage {...pageProps} noLogin variant={'sidebarMenu'}>
			<PageHeader title={title} />
			<GTMProductList list={'group'}>
				<ShopProductGroupGrid
					grouptags={grouptags}
					onPageChange={() => {
						scrollTop();
					}}
					paginationViewParams={paginationViewParams}
				/>
			</GTMProductList>
		</ShopPage>
	);
};
Group.propTypes = {
	grouptags: PropTypes.arrayOf(PropTypes.string).isRequired,
	paginationViewParams: PropTypes.object,
};

export const getServerSideProps = compose(
	MuiPaginationServerSideProps,
	shopServerSideProps,
)(async ({ locale, query, paginationViewParams, ...ctx }) => {
	const grouptags = query.grouptags.split(',');
	const { data: group_tags_result } = await apiGroupTagsRead({
		uids: grouptags,
	});

	const texts = grouptags.map((t) =>
		getTranslation(group_tags_result[t].name, locale),
	);

	return {
		props: {
			pageInfo: {
				title: texts.join(' '),
			},
			grouptags,
			paginationViewParams: paginationViewParams,
		},
	};
});
export default Group;
